import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-blocks',
  templateUrl: './home-blocks.component.html',
  styleUrls: ['./home-blocks.component.css']
})
export class HomeBlocksComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
